/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Modular_Wizard_Not_SetInputs */



/**
* | output |
* | --- |
* | "Not set" |
*
* @param {Spaces_Modular_Wizard_Not_SetInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_modular_wizard_not_set = /** @type {((inputs?: Spaces_Modular_Wizard_Not_SetInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Modular_Wizard_Not_SetInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Nicht festgelegt")
	return /** @type {LocalizedString} */ ("Not set")
});